import React, { useState, useEffect, useContext } from "react";
import FETCH from "../../utils/fetch";
import { MODULE_API } from "../../apis";
import { useHistory } from "react-router-dom";
import { IncomeReport } from "./IncomeDashboardComponets/IncomeReport";
import { IncomeChart } from "./IncomeDashboardComponets/IncomeChart";
import { IncomeTable } from "./IncomeDashboardComponets/IncomeTable";
import "./IncomeDashboard.css";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";
import moment from "moment";
import { ChartColors } from "../../components/ChartColors";
import { GlobalLoaderContext } from "../../utils/GlobalLoaderContext";
import ModalVideo from "../ModuleVideos/ModalVideo";
export const IncomeDashboard = () => {
  const history = useHistory();
  const { runWithLoader } = useContext(GlobalLoaderContext);
  const [loading, setLoading] = useState(false);
  const [incomeList, setIncomeList] = useState([]);
  const [dataReport, setDataReport] = useState(null);
  const [monthlyDataReport, setMonthlyDataReport] = useState(null);
  const [yearlyDataReport, setYearlyDataReport] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [incomeReport, setIncomeReport] = useState(null);

  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [cachedData, setCachedData] = useState({});

  const getIncomeList = async (page) => {
    if (cachedData && cachedData[page]) {
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      const attributeToFetch = [
        "Date Income Starts",
        "Gross Monthly Wages",
        "Date Income Ends",
        "Income Name",
        "Passive or Active",
        "Frequency of Pay Periods",
        "Net Amount",
      ];
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");

      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Income&page=${page}&limit=10&clientId=${ID}`
            : `?module=Income&page=${page}&limit=10`,
        body: { attributes: attributeToFetch },
      });
      if (datares && datares.records) {
        // setIncomeList(datares.records);
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
        const totalRecords = datares.records;
        // Helper functions
        const isCurrentYear = (date) =>
          new Date(date).getFullYear() === new Date().getFullYear();
        const isCurrentMonth = (date) => {
          const today = new Date();
          const recordDate = new Date(date);
          return (
            recordDate.getFullYear() === today.getFullYear() &&
            recordDate.getMonth() === today.getMonth()
          );
        };
        const isValidRecord = (rec) =>
          rec["Passive or Active"] && rec["Gross Monthly Wages"] !== undefined;
        // Separate records by type
        const passiveRecords = totalRecords.filter(
          (rec) => isValidRecord(rec) && rec["Passive or Active"] === "Passive"
        );
        const activeRecords = totalRecords.filter(
          (rec) => isValidRecord(rec) && rec["Passive or Active"] === "Active"
        );

        // Total sums
        const totalPassiveSum = passiveRecords.reduce(
          (sum, rec) => sum + +rec["Gross Monthly Wages"],
          0
        );
        const totalActiveSum = activeRecords.reduce(
          (sum, rec) => sum + +rec["Gross Monthly Wages"],
          0
        );
        const totalSum = totalPassiveSum + totalActiveSum;

        // Current year sums
        const currentYearPassiveSum = passiveRecords
          .filter(
            (rec) =>
              isCurrentYear(rec["Date Income Starts"]) ||
              isCurrentYear(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + +rec["Gross Monthly Wages"], 0);

        const currentYearActiveSum = activeRecords
          .filter(
            (rec) =>
              isCurrentYear(rec["Date Income Starts"]) ||
              isCurrentYear(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + rec["Gross Monthly Wages"], 0);

        // Current month sums
        const currentMonthPassiveSum = passiveRecords
          .filter(
            (rec) =>
              isCurrentMonth(rec["Date Income Starts"]) ||
              isCurrentMonth(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + +rec["Gross Monthly Wages"], 0);

        const currentMonthActiveSum = activeRecords
          .filter(
            (rec) =>
              isCurrentMonth(rec["Date Income Starts"]) ||
              isCurrentMonth(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + +rec["Gross Monthly Wages"], 0);

        const currentMonthTotalSum =
          currentMonthPassiveSum + currentMonthActiveSum;
        const currentYearTotalSum =
          currentYearPassiveSum + currentYearActiveSum;
        // Result object
        const resultObj = {
          totalPassiveSum,
          totalActiveSum,
          totalSum,
          currentYearPassiveSum,
          currentYearActiveSum,
          currentMonthPassiveSum,
          currentMonthActiveSum,
          currentMonthTotalSum,
          currentYearTotalSum,
        };
        setDataReport(resultObj);

        console.log("Current Year Active Sum:", resultObj);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getIncomeListAfterDelete = async (page) => {
    try {
      setLoading(true);
      const attributeToFetch = [
        "Date Income Starts",
        "Gross Monthly Wages",
        "Date Income Ends",
        "Income Name",
        "Passive or Active",
        "Frequency of Pay Periods",
        "Net Amount",
      ];
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Income&page=${page}&limit=10&clientId=${ID}`
            : `?module=Income&page=${page}&limit=10`,
        body: { attributes: attributeToFetch },
      });
      if (datares && datares.records) {
        // setIncomeList(datares.records);
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
        const totalRecords = datares.records;
        // Helper functions
        const isCurrentYear = (date) =>
          new Date(date).getFullYear() === new Date().getFullYear();
        const isCurrentMonth = (date) => {
          const today = new Date();
          const recordDate = new Date(date);
          return (
            recordDate.getFullYear() === today.getFullYear() &&
            recordDate.getMonth() === today.getMonth()
          );
        };
        const isValidRecord = (rec) =>
          rec["Passive or Active"] && rec["Gross Monthly Wages"] !== undefined;
        // Separate records by type
        const passiveRecords = totalRecords.filter(
          (rec) => isValidRecord(rec) && rec["Passive or Active"] === "Passive"
        );
        const activeRecords = totalRecords.filter(
          (rec) => isValidRecord(rec) && rec["Passive or Active"] === "Active"
        );

        // Total sums
        const totalPassiveSum = passiveRecords.reduce(
          (sum, rec) => sum + +rec["Gross Monthly Wages"],
          0
        );
        const totalActiveSum = activeRecords.reduce(
          (sum, rec) => sum + +rec["Gross Monthly Wages"],
          0
        );
        const totalSum = totalPassiveSum + totalActiveSum;

        // Current year sums
        const currentYearPassiveSum = passiveRecords
          .filter(
            (rec) =>
              isCurrentYear(rec["Date Income Starts"]) ||
              isCurrentYear(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + +rec["Gross Monthly Wages"], 0);

        const currentYearActiveSum = activeRecords
          .filter(
            (rec) =>
              isCurrentYear(rec["Date Income Starts"]) ||
              isCurrentYear(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + rec["Gross Monthly Wages"], 0);

        // Current month sums
        const currentMonthPassiveSum = passiveRecords
          .filter(
            (rec) =>
              isCurrentMonth(rec["Date Income Starts"]) ||
              isCurrentMonth(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + +rec["Gross Monthly Wages"], 0);

        const currentMonthActiveSum = activeRecords
          .filter(
            (rec) =>
              isCurrentMonth(rec["Date Income Starts"]) ||
              isCurrentMonth(rec["Date Income Ends"])
          )
          .reduce((sum, rec) => sum + +rec["Gross Monthly Wages"], 0);

        const currentMonthTotalSum =
          currentMonthPassiveSum + currentMonthActiveSum;
        const currentYearTotalSum =
          currentYearPassiveSum + currentYearActiveSum;
        // Result object
        const resultObj = {
          totalPassiveSum,
          totalActiveSum,
          totalSum,
          currentYearPassiveSum,
          currentYearActiveSum,
          currentMonthPassiveSum,
          currentMonthActiveSum,
          currentMonthTotalSum,
          currentYearTotalSum,
        };
        setDataReport(resultObj);

        console.log("Current Year Active Sum:", resultObj);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      setIncomeList(datares.records);
    }
    if (datares && datares.pagination) {
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };

  const deletePost = async (id) => {
    console.log("delete is", id);
    swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        try {
          setLoading(true);
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          setCachedData({});
          setIncomeList([]);
          await getIncomeListAfterDelete(1);
          await getIncomeChartData();
          setLoading(false);
          // return res;
        } catch (error) {
          // setLoading(false);
          setLoading(false);
        }
      }
    });
  };

  const getIncomeTotalMonthly = async () => {
    try {
      setLoading(true);
      const date = moment();
      const startDate = date.startOf("month").format("YYYY-MM-DD"); // Start of the month
      const endDate = date.endOf("month").format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchIncomeSum(startDate, endDate);
      if (datares && datares.data) {
        const monthlyData = datares.data;
        let monthlyResponse = {
          ...datares.data,
          totalMonthly: monthlyData
            ? (+monthlyData.Active || 0) + (+monthlyData.Passive || 0)
            : 0,
        };
        setMonthlyDataReport(monthlyResponse);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getIncomeTotalYearly = async () => {
    try {
      setLoading(true);
      const currentDate = moment();
      const startDate = currentDate
        .clone()
        .startOf("year")
        .format("YYYY-MM-DD");
      // const endDate = currentDate.clone().endOf("year").format("YYYY-MM-DD");
      const endDate = currentDate.clone().endOf("month").format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchIncomeSum(startDate, endDate);
      if (datares && datares.data) {
        const yearlyData = datares.data;
        let yearlyResponse = {
          ...datares.data,
          totalYearly: yearlyData
            ? (+yearlyData.Active || 0) + (+yearlyData.Passive || 0)
            : 0,
        };
        setYearlyDataReport(yearlyResponse);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getIncomeChartData = async () => {
    try {
      setLoading(true);
      const currentDate = moment();
      const startDate = currentDate
        .clone()
        .subtract(1, "year")
        .format("YYYY-MM-DD");

      const endDate = currentDate.clone().format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchIncomeChartData(startDate, endDate);
      if (datares && datares.data) {
        const generatedChartData = generateIncomeChartData(
          datares.data,
          startDate,
          endDate
        );
        const incomeSummary = calculateIncomeSummary(datares.data);
        setChartData(generatedChartData);
        setIncomeReport(incomeSummary);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const calculateIncomeSummary = (incomeData) => {
    const currentYear = moment().year();
    const currentMonth = moment().format("MMM YYYY");
    const today = moment();
    const startOfYear = moment().startOf("year");
  
    let yearlyActiveIncome = 0;
    let yearlyPassiveIncome = 0;
    let monthlyActiveIncome = 0;
    let monthlyPassiveIncome = 0;
  
    const frequencyMultipliers = {
      Annually: 12,
      "Bi-Monthly": 2,
      "Bi-Weekly": 0.5, // 2 occurrences per month
      Monthly: 1,
      "One-Time": 0, // Applies only in the start month
      Quarterly: 3,
      "Semi-Annually": 6,
      Weekly: 0.25, // 4 occurrences per month
    };
  
    incomeData.forEach((item) => {
      const incomeStart = moment(item.income_start_date || today);
      const incomeEnd = moment(item.income_end_date || today);
      const frequency = item.frequency || "Monthly";
      const type = item.active_passive_val; // "Active" or "Passive"
      const monthlyIncome = item.gross_monthly_wages || 0;
  
      if (!frequencyMultipliers.hasOwnProperty(frequency)) return;
  
      const interval = frequencyMultipliers[frequency];
  
      // Ensure the income period overlaps with the current year
      if (incomeEnd.isBefore(startOfYear) || incomeStart.isAfter(moment())) return;
  
      let effectiveStart = moment.max(incomeStart, startOfYear);
      let effectiveEnd = moment.min(incomeEnd, moment());
  
      for (
        let date = effectiveStart.clone();
        date.isSameOrBefore(effectiveEnd);
        date.add(1, "month")
      ) {
        const monthLabel = date.format("MMM YYYY");
  
        let occurrences = 1; // Default for monthly
        if (frequency === "Weekly") occurrences = 4;
        else if (frequency === "Bi-Weekly") occurrences = 2;
        else if (frequency === "One-Time") occurrences = date.isSame(effectiveStart, "month") ? 1 : 0;
        else if (interval > 1) occurrences = (date.month() - effectiveStart.month()) % interval === 0 ? 1 : 0;
  
        if (type === "Active") {
          yearlyActiveIncome += monthlyIncome * occurrences;
          if (monthLabel === currentMonth) {
            monthlyActiveIncome += monthlyIncome * occurrences;
          }
        } else {
          yearlyPassiveIncome += monthlyIncome * occurrences;
          if (monthLabel === currentMonth) {
            monthlyPassiveIncome += monthlyIncome * occurrences;
          }
        }
      }
    });
  
    return {
      yearlyActiveIncome:yearlyActiveIncome,
      yearlyPassiveIncome:yearlyPassiveIncome,
      monthlyActiveIncome:monthlyActiveIncome,
      monthlyPassiveIncome:monthlyPassiveIncome,
      totalYearly:yearlyActiveIncome + yearlyPassiveIncome,
      totalMonthly:monthlyActiveIncome + monthlyPassiveIncome,
    };
  };

  // generateIncomeChartData without frequncy 
  // const generateIncomeChartData = (incomeData, startDate, endDate) => {
  //   const momentStartDate = moment(startDate);
  //   const momentEndDate = moment(endDate);

  //   // Generate dynamic month labels from start to end dates
  //   const monthLabels = [];
  //   let currentMonth = momentStartDate.clone();
  //   while (currentMonth.isSameOrBefore(momentEndDate)) {
  //     monthLabels.push(currentMonth.format("MMM YYYY"));
  //     currentMonth.add(1, "month");
  //   }

  //   const totalNetIncome = Array(monthLabels.length).fill(0);

  //   // Initialize dataset for each income type
  //   const incomeDatasets = incomeData
  //     .map((item, index) => {
  //       const monthlyData = Array(monthLabels.length).fill(0);
  //       const incomeStart = moment(item.income_start_date);
  //       const incomeEnd = moment(item.income_end_date);

  //       // Ensure the income period overlaps with the specified date range
  //       if (
  //         incomeEnd.isBefore(momentStartDate) ||
  //         incomeStart.isAfter(momentEndDate)
  //       )
  //         return null;

  //       const effectiveStart = moment.max(incomeStart, momentStartDate);
  //       const effectiveEnd = moment.min(incomeEnd, momentEndDate);

  //       const totalMonths = effectiveEnd.diff(effectiveStart, "months") + 1;
  //       const monthlyIncome = item.net_amount / totalMonths;
  //       const monthlyWages = item.gross_monthly_wages;

  //       for (
  //         let date = effectiveStart.clone();
  //         date.isSameOrBefore(effectiveEnd);
  //         date.add(1, "month")
  //       ) {
  //         const monthIndex = monthLabels.findIndex(
  //           (label) => label === date.format("MMM YYYY")
  //         );
  //         if (monthIndex !== -1) {
  //           monthlyData[monthIndex] += parseFloat(monthlyWages.toFixed(2));
  //           totalNetIncome[monthIndex] += parseFloat(monthlyIncome.toFixed(2));
  //         }
  //       }

  //       return {
  //         label: item.income_name || "Unnamed Income",
  //         type: "bar",
  //         data: monthlyData,
  //         backgroundColor: ChartColors[index % ChartColors.length],
  //         borderColor: ChartColors[index % ChartColors.length],
  //         stack: "stack1",
  //       };
  //     })
  //     .filter((dataset) => dataset !== null);

  //   // Add "Net Income" dataset
  //   let netIncomeChartData = {
  //     label: "Net Income",
  //     type: "line",
  //     data: totalNetIncome,
  //     fill: false,
  //     borderColor: "#11C4C1",
  //   };
  //   // incomeDatasets.push({
  //   //   label: "Net Income",
  //   //   type: "line",
  //   //   data: totalNetIncome,
  //   //   fill: false,
  //   //   borderColor: "#11C4C1",
  //   // });

  //   return {
  //     labels: monthLabels,
  //     datasets: [netIncomeChartData, ...incomeDatasets],
  //   };
  // };

  // generateIncomeChartData with frequncy but conderising for each month by dividing.
  // const generateIncomeChartData = (incomeData, startDate, endDate) => {
  //   const momentStartDate = moment(startDate);
  //   const momentEndDate = moment(endDate);
  
  //   // Generate dynamic month labels from start to end dates
  //   const monthLabels = [];
  //   let currentMonth = momentStartDate.clone();
  //   while (currentMonth.isSameOrBefore(momentEndDate)) {
  //     monthLabels.push(currentMonth.format("MMM YYYY"));
  //     currentMonth.add(1, "month");
  //   }
  
  //   const totalNetIncome = Array(monthLabels.length).fill(0);
  
  //   const frequencyMultipliers = {
  //     Annually: 1 / 12,
  //     "Bi-Monthly": 6, // Twice a year
  //     "Bi-Weekly": 2, // Approximation: 2 occurrences per month
  //     Monthly: 1,
  //     "One-Time": 0, // Only counts for its start month
  //     Quarterly: 3 / 12, // Every 3 months
  //     "Semi-Annually": 1 / 6,
  //     Weekly: 4, // Approximation: 4 occurrences per month
  //   };
  
  //   // Initialize dataset for each income type
  //   const incomeDatasets = incomeData
  //     .map((item, index) => {
  //       const monthlyData = Array(monthLabels.length).fill(0);
  //       const incomeStart = moment(item.income_start_date);
  //       const incomeEnd = moment(item.income_end_date);
  //       const frequency = item.frequency || "Monthly";
  
  //       if (!frequencyMultipliers.hasOwnProperty(frequency)) return null;
  
  //       // Ensure the income period overlaps with the specified date range
  //       if (
  //         incomeEnd.isBefore(momentStartDate) ||
  //         incomeStart.isAfter(momentEndDate)
  //       )
  //         return null;
  
  //       const effectiveStart = moment.max(incomeStart, momentStartDate);
  //       const effectiveEnd = moment.min(incomeEnd, momentEndDate);
  
  //       const multiplier = frequencyMultipliers[frequency];
  //       const monthlyIncome = item.net_amount * multiplier;
  //       const monthlyWages = item.gross_monthly_wages * multiplier;
  
  //       for (
  //         let date = effectiveStart.clone();
  //         date.isSameOrBefore(effectiveEnd);
  //         date.add(1, "month")
  //       ) {
  //         const monthIndex = monthLabels.findIndex(
  //           (label) => label === date.format("MMM YYYY")
  //         );
  //         if (monthIndex !== -1) {
  //           monthlyData[monthIndex] += parseFloat(monthlyWages.toFixed(2));
  //           totalNetIncome[monthIndex] += parseFloat(monthlyIncome.toFixed(2));
  //         }
  //       }
  
  //       return {
  //         label: item.income_name || "Unnamed Income",
  //         type: "bar",
  //         data: monthlyData,
  //         backgroundColor: ChartColors[index % ChartColors.length],
  //         borderColor: ChartColors[index % ChartColors.length],
  //         stack: "stack1",
  //       };
  //     })
  //     .filter((dataset) => dataset !== null);
  
  //   // Add "Net Income" dataset
  //   let netIncomeChartData = {
  //     label: "Net Income",
  //     type: "line",
  //     data: totalNetIncome,
  //     fill: false,
  //     borderColor: "#11C4C1",
  //   };
  
  //   return {
  //     labels: monthLabels,
  //     datasets: [netIncomeChartData, ...incomeDatasets],
  //   };
  // };

  // generateIncomeChartData with frequncy but considering accoriding to frequncy.
  const generateIncomeChartData = (incomeData, startDate, endDate) => {
    const momentStartDate = moment(startDate);
    const momentEndDate = moment(endDate);
  
    // Generate dynamic month labels from start to end dates
    const monthLabels = [];
    let currentMonth = momentStartDate.clone();
    while (currentMonth.isSameOrBefore(momentEndDate)) {
      monthLabels.push(currentMonth.format("MMM YYYY"));
      currentMonth.add(1, "month");
    }
  
    const totalNetIncome = Array(monthLabels.length).fill(0);
  
    // Income frequencies and occurrences per month
    const frequencyMultipliers = {
      Annually: 12,
      "Bi-Monthly": 2,
      "Bi-Weekly": 0.5, // 2 occurrences per month
      Monthly: 1,
      "One-Time": 0, // Applies only in the start month
      Quarterly: 3,
      "Semi-Annually": 6,
      Weekly: 0.25, // 4 occurrences per month
    };
  
    const incomeDatasets = incomeData
      .map((item, index) => {
        const monthlyData = Array(monthLabels.length).fill(0);
        const incomeStart = moment(item.income_start_date);
        const incomeEnd = moment(item.income_end_date);
        const frequency = item.frequency || "Monthly";
  
        if (!frequencyMultipliers.hasOwnProperty(frequency)) return null;
  
        // Ensure the income period overlaps with the specified date range
        if (
          incomeEnd.isBefore(momentStartDate) ||
          incomeStart.isAfter(momentEndDate)
        )
          return null;
  
        const effectiveStart = moment.max(incomeStart, momentStartDate);
        const effectiveEnd = moment.min(incomeEnd, momentEndDate);
  
        const interval = frequencyMultipliers[frequency];
        const monthlyIncome = item.net_amount;
        const monthlyWages = item.gross_monthly_wages;
  
        for (
          let date = effectiveStart.clone();
          date.isSameOrBefore(effectiveEnd);
          date.add(1, "month")
        ) {
          const monthIndex = monthLabels.findIndex(
            (label) => label === date.format("MMM YYYY")
          );
          if (monthIndex !== -1) {
            if (interval === 0) {
              // Handle One-Time Income
              if (frequency === "One-Time" && monthIndex === monthLabels.indexOf(effectiveStart.format("MMM YYYY"))) {
                monthlyData[monthIndex] += parseFloat(monthlyWages.toFixed(2));
                totalNetIncome[monthIndex] += parseFloat(monthlyIncome.toFixed(2));
              }
            } else if (interval <= 1) {
              // Weekly or Bi-Weekly
              const occurrences = frequency === "Weekly" ? 4 : frequency !== "Monthly" ? 2 : 1;
              monthlyData[monthIndex] += parseFloat((monthlyWages * occurrences).toFixed(2));
              totalNetIncome[monthIndex] += parseFloat((monthlyIncome * occurrences).toFixed(2));
            } else if ((monthIndex - monthLabels.indexOf(effectiveStart.format("MMM YYYY"))) % interval === 0) {
              // Quarterly, Bi-Monthly, Semi-Annually, Annually
              monthlyData[monthIndex] += parseFloat(monthlyWages.toFixed(2));
              totalNetIncome[monthIndex] += parseFloat(monthlyIncome.toFixed(2));
            }
          }
        }
  
        return {
          label: item.income_name || "Unnamed Income",
          type: "bar",
          data: monthlyData,
          backgroundColor: ChartColors[index % ChartColors.length],
          borderColor: ChartColors[index % ChartColors.length],
          stack: "stack1",
        };
      })
      .filter((dataset) => dataset !== null);
  
    // Add "Net Income" dataset
    let netIncomeChartData = {
      label: "Net Income",
      type: "line",
      data: totalNetIncome,
      fill: false,
      borderColor: "#11C4C1",
    };
  
    return {
      labels: monthLabels,
      datasets: [netIncomeChartData, ...incomeDatasets],
    };
  };  

  useEffect(() => {
    getIncomeList(currentPage);
  }, [currentPage]);

  const getAll = async () => {
    // await getIncomeList(1);
    setLoading(true);
    await runWithLoader(async () => {
      await getIncomeTotalMonthly();
      await getIncomeTotalYearly();
      await getIncomeChartData();
       }, () => {
    // 👇 This runs only if global loader actually shows after 4s
    setLoading(false);
  });
    setLoading(false);
  };
  useEffect(() => {
    getAll();
  }, []);

  return (
    <div className="incomeMain">
      <ModalVideo module="Source of Income" autoOpen={true} />
      <div className="Incomecreate">
        <button
          className="addbuttonincome"
          onClick={() => {
            history.push("/income_new");
          }}
        >
          {" "}
          + Add Income
        </button>
      </div>

      <div className="incomeMainReport" style={{ position: "relative" }}>
        <IncomeReport
          data={dataReport && dataReport}
          monthlyDataReport={monthlyDataReport && monthlyDataReport}
          yearlyDataReport={yearlyDataReport && yearlyDataReport}
          incomeReport={incomeReport && incomeReport}
          isLoading={loading}
        />
        <NewLoader isLoading={loading} />
      </div>
      <div className="incomeTableCard" style={{ position: "relative" }}>
        <IncomeChart
          data={incomeList && incomeList}
          chartData={chartData && chartData}
          isLoading={loading}
        />
        <NewLoader isLoading={loading} />
      </div>
      <div className="incomeTableCard" style={{ position: "relative" }}>
        <IncomeTable
          data={incomeList && incomeList}
          isLoading={loading}
          getList={getIncomeList}
          deletePost={deletePost}
          page={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
        <NewLoader isLoading={loading} />
      </div>
    </div>
  );
};
